export default __webpack_public_path__ + "static/media/Treatment_Grand_mellow.b11753bd.png";